import React from "react";
import { ShoppingCart } from "react-feather";

import templateConfig from "../../../templateConfig";

const Footer = props => (
   <footer>
      <div className="container-fluid">
         <p className="text-center">
            © 2020{" "}
            <a
               href="http://www.zincmore.com.ar"
               rel="noopener noreferrer"
               target="_blank"
            >
               SM -{" "}
            </a>
            Dev. <i className="ft-heart font-small-3" />            
            <a href="http://www.zincmore.com.ar/" rel="noopener noreferrer" target="_blank">
               {" "}
               Zinc
            </a>
         </p>
      </div>
   </footer>
);

export default Footer;
